export default "__VITE_ASSET__6gTUk6lO__"